import { Field } from '@/shared/ui/Form/Field/index'
import {
  SelectContent,
  SelectIcon,
  SelectItemContainer,
  SelectRoot,
  SelectTrigger,
  SelectValue,
  SelectViewPort,
} from '@/shared/ui/Form/Select/styles'
import { Text } from '@/shared/ui/Typography'
import * as SelectPrimitive from '@radix-ui/react-select'
import { IconCheck, IconChevronDown, IconChevronUp } from '@tabler/icons-react'
import { type ComponentProps, forwardRef } from 'react'

type SelectProps = ComponentProps<typeof SelectPrimitive.Root> & {
  options: { label: string; value: string }[]
  label: string
  error?: string
  className?: string
  disabledMessage?: string
}

export const Select = forwardRef<HTMLButtonElement, SelectProps>(
  ({ options, label, error, disabledMessage, ...props }, forwardedRef) => {
    const { disabled, ...restProps } = props
    const triggerTitle =
      disabled && disabledMessage ? disabledMessage : undefined

    return (
      <Field label={label} error={error}>
        <SelectRoot {...restProps} disabled={disabled}>
          <SelectTrigger
            ref={forwardedRef}
            id={label}
            disabled={disabled}
            title={triggerTitle}
          >
            <SelectValue placeholder="Selecione uma opção" />
            <SelectIcon>
              <IconChevronDown />
            </SelectIcon>
          </SelectTrigger>

          <SelectContent>
            <SelectPrimitive.ScrollUpButton>
              <IconChevronUp />
            </SelectPrimitive.ScrollUpButton>
            <SelectViewPort>
              <SelectPrimitive.Group>
                {options.map((option) => (
                  <SelectItem key={option.value} value={option.value}>
                    {option.label}
                  </SelectItem>
                ))}
              </SelectPrimitive.Group>
            </SelectViewPort>
            <SelectPrimitive.ScrollDownButton />
            <SelectPrimitive.Arrow />
          </SelectContent>
        </SelectRoot>
      </Field>
    )
  },
)

type SelectItemProps = ComponentProps<typeof SelectPrimitive.Item>

export const SelectItem = forwardRef<HTMLDivElement, SelectItemProps>(
  ({ children, ...props }, forwardedRef) => {
    return (
      <SelectItemContainer {...props} ref={forwardedRef}>
        <SelectPrimitive.ItemText asChild>
          <Text>{children}</Text>
        </SelectPrimitive.ItemText>
        <SelectPrimitive.ItemIndicator>
          <IconCheck />
        </SelectPrimitive.ItemIndicator>
      </SelectItemContainer>
    )
  },
)
